import {moment} from 'moment';
import {AbstractPart} from "./AbstractPart";
import {nsForm} from "../../nsForm";
import {IFormPartParameters} from "./index";
import {convertToServerString} from "../../../../util/datetime";
import {INPUT_DATE_FORMAT} from "../../../../constants";
import str2Bool = nsForm.str2Bool;
import DATE_FORMAT = nsForm.DATE_FORMAT;
import dateboxHtml from './datebox.html?raw';

export let template = dateboxHtml;

export class viewModel extends AbstractPart<string> {
    private readonly isRequired: boolean;

    constructor(params: IFormPartParameters) {
        super(params);
        switch (this.value()) {
            case undefined:
            case null:
                if ((this.parameters[2] ?? '') !== '') {
                    this.value(moment(this.parameters[2], DATE_FORMAT).format(INPUT_DATE_FORMAT));
                }
        }
        this.isRequired = str2Bool(this.parameters[3] ?? '');
        this.attr = {
            required: this.isRequired,
        };
    }

    override isValid(): boolean {
        const val = this.value() ?? '';
        const a = this.isRequired ? !!val : true;
        if (!a) {
            this.et.update(true, this.value, 'Mangler dato');
            return false;
        }
        const b = !!val ? moment(val, INPUT_DATE_FORMAT)?.isValid(): true;
        if (!b) {
            this.et.update(true, this.value, 'Ugyldig dato');
            return false;
        }
        this.et.update(false, this.value);
        return true;
    }

    override getSubmitData(): string | null {
        const val = this.value();
        return val ? convertToServerString(moment(val, INPUT_DATE_FORMAT), true) : null;
    }
}
